module.exports = __webpack_public_path__ + "img/case-szdx.8d9896fa.png";